<template>
  <div class="data-delete-sticky">
    <slot />
  </div>
</template>

<!-- eslint-disable-next-line vue/enforce-style-attribute -->
<style lang="scss">
@import "data-delete-sticky";
</style>
